import { Hide, Select } from "shared/components";
import { AmenitiesSelect } from "./components/AmenitiesSelect";
import { SectionCard } from "shared/app/SectionCard";

const petOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

interface AmenitiesFormProps {
  headerExtra?: React.ReactNode;
  register: any;
  selectedAmenities: number[];
  isUnit?: boolean;
  footer?: React.ReactNode;
  level?: "property" | "unit";
}

export const AmenitiesForm = (props: AmenitiesFormProps) => {
  const {
    isUnit,
    register,
    selectedAmenities,
    level = "property",
    headerExtra,
    footer
  } = props;

  const handleSelect = (value: number[]) => {
    register("amenities").onChange(value);
  };

  return (
    <SectionCard title="Amenities" headerExtra={headerExtra} footer={footer}>
      <div className="space-y-4">
        <Hide if={isUnit}>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Select
                id="cat-allowed"
                label="Cat allowed"
                options={petOptions}
                required
                {...register("cats_allowed")}
              />
            </div>
            <div>
              <Select
                id="dog-allowed"
                label="Dog allowed"
                options={petOptions}
                required
                {...register("dogs_allowed")}
              />
            </div>
          </div>
        </Hide>

        <AmenitiesSelect
          level={level}
          onSelect={handleSelect}
          selectedAmenities={selectedAmenities}
        />
      </div>
    </SectionCard>
  );
};
